import { useEffect, useRef, useState } from 'react';
import useBundleTranslation from 'i18n';
import { monitorAPI } from 'api/monitor';
import { Box } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';

export function SystemDateTimeLabel() {
    const { t } = useBundleTranslation(['app/notification/my-notification']);
    const [systemDate, setSystemDate] = useState('');
    const [systemTime, setSystemTime] = useState('');
    const timerId = useRef<number>();
    const systemDateTimeTick = () => {
        monitorAPI.loadSystemDateTimeData().then((response) => {
            if (response.data.status === 'OK') {
                setSystemDate(response.data.data.systemDate);
                setSystemTime(response.data.data.systemTime);
            }
        });
    };

    useEffect(() => {
        timerId.current = window.setInterval(() => systemDateTimeTick(), 30000);
        systemDateTimeTick();
        return () => clearInterval(timerId.current);
    }, []);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {systemDate == '' ? (
                <>
                    <IconMi icon={'clock'} fontSize={'16'} sx={{ mx: 1 }} /> {t('loading___')}
                </>
            ) : (
                <>
                    {`${systemDate} ${t('system')}`}
                    <IconMi icon={'clock'} fontSize={'16'} sx={{ mx: 1 }} />
                    {`${systemTime}`}
                </>
            )}
        </Box>
    );
}
